<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Please Confirm</h1>
        </template>
        
        <p>All future emails from them will land in your inbox immediately. Are you sure?</p>

        <template v-slot:footer>
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                state="Confirming..."
                @click.native="submit"
            >
                Confirm
            </progressable-button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    methods: {
        submit() {
            this.$emit('resolve');
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>